// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"259":"component---src-pages-editor-js","269":"component---src-templates-storyblok-entry-js","351":"commons","532":"styles"}[chunkId] + "-" + {"259":"aa469b212dfb936a7839","269":"462352a6f62ad61a7a96","351":"4d29ae21e4b8b64d774d","532":"c1b30e72dd1c97ef80cb"}[chunkId] + ".js";
};